import React, { useContext } from 'react'
import { ModalContext } from 'providers/Modal'
import { showHideRecaptchaBadge } from 'utils/recaptchaToken'
import 'styles/close.scss'
import useSignUpData from 'hooks/useSignUpData'

const Close = () => {
  const [defaultData, , updateData] = useSignUpData()
  const { setActive } = useContext(ModalContext)
  const close = () => {
    showHideRecaptchaBadge(true)
    setActive(null)
    updateData(defaultData)
  }
  return (
    <div data-testid="close_modal" className="layerClose" onClick={close} />
  )
}

export default Close
